/**
 * Why a broker group's timezone doesn't fit its country, or undefined when it does (or
 * either is missing, or the country isn't one of `countries`), e.g. "Pacific/Auckland isn't
 * a timezone in Australia". countries is from listCountries.
 */
export const getTimezoneMismatch = (countries, countryCode, timezone) => {
	const country = countries?.[countryCode];
	if (!country || !timezone || country.timezones.includes(timezone)) {
		return undefined;
	}
	return `${timezone} isn't a timezone in ${country.countryName}`;
};
